import { useCallback, useEffect, useRef, useState } from "react";

// Mede a altura de um elemento e acompanha mudancas. O layout usa para
// descontar a faixa de aviso de conta da altura das telas de altura cheia
// (Conversas, Kanban...), que calculam o tamanho em % do <main>. Sem
// ResizeObserver (jsdom, navegador antigo) devolve 0 e nada muda.
const useAlturaObservada = () => {
  const [altura, setAltura] = useState(0);
  const observador = useRef(null);

  const desconectar = () => {
    if (observador.current) {
      observador.current.disconnect();
      observador.current = null;
    }
  };

  const ref = useCallback((elemento) => {
    desconectar();
    if (!elemento || typeof ResizeObserver === "undefined") {
      setAltura(0);
      return;
    }
    observador.current = new ResizeObserver((entradas) => {
      const entrada = entradas[0];
      setAltura(entrada ? Math.round(entrada.contentRect.height) : 0);
    });
    observador.current.observe(elemento);
  }, []);

  useEffect(() => desconectar, []);

  return [ref, altura];
};

export default useAlturaObservada;
